/* Catalog Insights tab — macro→micro exclusive-vs-full view.
   Page padding comes from Layout's .main; the universe title + tab bar sit above
   via PlatformsLayout, so this starts straight into controls. */

.page {
  display: flex;
  flex-direction: column;
  gap: var(--space-5);
  padding-top: var(--space-4);
}

/* ── Controls ─────────────────────────────────────────────────────────────── */
.controls {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-4);
}

.selects {
  display: flex;
  align-items: center;
  gap: var(--space-2);
}

/* Fixed, content-appropriate widths so the three sit cleanly in a row and the
   trigger doesn't stretch to fill. */
.select {
  width: 180px;
  flex: none;
}

/* Only stack on genuinely narrow viewports, and do it tidily. */
@media (max-width: 720px) {
  .controls {
    flex-direction: column;
    align-items: stretch;
  }
  .selects {
    flex-wrap: wrap;
  }
  .select {
    width: auto;
    flex: 1 1 160px;
  }
}

/* ── Headline takeaway ────────────────────────────────────────────────────── */
.takeaway {
  margin: 0;
  padding: var(--space-3) var(--space-4);
  background: var(--bg-card);
  border: 1px solid var(--border-subtle);
  border-left: 3px solid var(--accent-secondary);
  border-radius: var(--radius-md);
  color: var(--text-secondary);
  font-size: var(--text-md);
  line-height: 1.5;
}

.takeaway strong {
  color: var(--text-primary);
  font-weight: var(--weight-semi);
}

.takeawayPct {
  color: var(--accent-secondary-text) !important;
  font-variant-numeric: tabular-nums;
}

/* ── Sections ─────────────────────────────────────────────────────────────── */
.section {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
}

.sectionHead {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.sectionTitle {
  margin: 0;
  font-family: var(--font-sans);
  font-size: var(--text-lg);
  font-weight: var(--weight-semi);
  letter-spacing: var(--tracking-tight);
  color: var(--text-primary);
}

.sectionMeta {
  margin: 0;
  font-size: var(--text-sm);
  color: var(--text-muted);
}

/* ── Chart grid ───────────────────────────────────────────────────────────── */
.chartRow {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: var(--space-4);
}

@media (max-width: 900px) {
  .chartRow {
    grid-template-columns: 1fr;
  }
}

.chartCard {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  padding: var(--space-4);
  background: var(--bg-card);
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-lg);
}

.chartTitle {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  margin: 0;
  font-size: var(--text-sm);
  font-weight: var(--weight-medium);
  color: var(--text-secondary);
}

.chartTitleIcon {
  display: inline-flex;
  color: var(--text-muted);
}

.shareLabel {
  font-size: 10px;
  font-weight: var(--weight-semi);
  font-variant-numeric: tabular-nums;
}

.sectionAccent {
  color: var(--accent-secondary-text);
  font-weight: var(--weight-semi);
}

.empty {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 240px;
  margin: 0;
  color: var(--text-muted);
  font-size: var(--text-sm);
}

/* Tabular numerals everywhere a figure appears in the charts. */
.chartCard :global(.recharts-cartesian-axis-tick-value),
.chartCard :global(text) {
  font-variant-numeric: tabular-nums;
}

/* ── States ───────────────────────────────────────────────────────────────── */
.loading {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 320px;
}

.errorMsg {
  padding: var(--space-4);
  background: var(--bg-card);
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-md);
  color: var(--text-secondary);
  font-size: var(--text-sm);
}

